import React from "react";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { ContentMain, Page, ScreenView } from "../../style/default";

function NotFound() {
	return (
		<Page>
			<Sidebar />
			<ScreenView>
				<ContentMain>
					<p>Page Not Found</p>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export default NotFound;
